"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** @module BryxApi */
var spoonClient_1 = require("../../spoonClient");
var device_1 = require("../functions/device");
/**
 * Mixin class for session API calls,
 * such as signing in or signing out.
 * @TODO Find way to pass in device id and device name.
 * @TODO Should not be using config.version, use this.version instead.
 * @TODO Device type probably should be 'management', and should be dynamic.
 */
var SessionMixin = /** @class */ (function () {
    function SessionMixin() {
    }
    /**
     * Signs in.
     * @TODO Find way to pass in device id.
     * @param email
     * @param password
     * @param token
     * @param deviceId Device id from local storage.
     * @param callback
     */
    SessionMixin.prototype.signIn = function (email, password, token, callback) {
        var _this = this;
        var authBody = {
            email: email,
            password: password,
            token: token,
            deviceId: this.local.deviceId,
            deviceName: (0, device_1.getDeviceName)(this.siteName),
            canUseForLocation: false,
            deviceType: this.platform,
            appVersion: this.version,
        };
        var wrappedCallback = function (request, response) {
            _this.authCallback(request, response, callback);
        };
        this.http.post('/authorization/', null, authBody, wrappedCallback);
    };
    SessionMixin.prototype.signInWithTotpKey = function (username, password, totp, callback) {
        var _this = this;
        var authBody = {
            username: username,
            password: password,
            totp: totp,
        };
        var wrappedCallback = function (request, response) {
            _this.authCallback(request, response, callback);
        };
        this.http.post('/authorization', null, authBody, wrappedCallback);
    };
    // /**
    //  * Signs in.
    //  * @TODO Find way to pass in device id.
    //  * @param email
    //  * @param password
    //  * @param token
    //  * @param deviceId Device id from local storage.
    //  * @param callback
    //  */
    // public signIn(
    //   email: string,
    //   password: string,
    //   token: string | null,
    //   callback: (result: ApiResult<AuthModel>) => void,
    // ): void {
    //   const authBody = {
    //     email: email,
    //     password: password,
    //     token: token,
    //     deviceId: (this as any).local.deviceId, // BryxLocal.getDeviceId(),
    //     deviceName: getDeviceName((this as any).siteName),
    //     canUseForLocation: false,
    //     deviceType: (this as any).platform,
    //     appVersion: (this as any).version,
    //   };
    //
    //   const wrappedCallback = (request: HttpRequest, response: HttpResponse) => {
    //     (this as any).authCallback(request, response, callback);
    //   };
    //
    //   (this as any).http.post('/authorization/', null, authBody, wrappedCallback);
    // }
    /**
     * Signs in using API key.
     * @param apiKey
     * @param deviceId
     * @param callback
     */
    SessionMixin.prototype.signInWithApiKey = function (apiKey, callback) {
        var _this = this;
        var authBody = {
            apiKey: apiKey,
            deviceId: this.local.deviceId,
            deviceName: (0, device_1.getDeviceName)(this.siteName),
            canUseForLocation: false,
            deviceType: this.platform,
            appVersion: this.version,
        };
        var wrappedCallback = function (request, response) {
            _this.authCallback(request, response, callback);
        };
        this.http.post('/authorization/', null, authBody, wrappedCallback);
    };
    /**
     * Update session data.
     * @param callback
     */
    SessionMixin.prototype.session = function (callback) {
        var _this = this;
        var authBody = {
            appVersion: this.version,
        };
        this.http.put('/authorization/', null, authBody, this.unauthenticatedCallback(function (request, response) {
            _this.authCallback(request, response, callback);
        }));
    };
    /**
     * Signs user out.
     * (Should make sure to clear user data in callback on success.)
     * @param callback
     */
    SessionMixin.prototype.signOut = function (callback) {
        var _this = this;
        var wrappedCallback = function (request, response) {
            if (response.status == spoonClient_1.ResponseStatus.Success) {
                // BryxLocal.clear();
                callback(_this.apiSuccess(null));
            }
            else {
                // callback((this as any).apiFailureWithResponse<null>(response));
                callback(_this.apiFailureWithResponse(response));
            }
        };
        this.http.del('/authorization/', null, wrappedCallback);
    };
    return SessionMixin;
}());
exports.default = SessionMixin;
//# sourceMappingURL=SessionMixin.js.map